import React, { useEffect, useState } from 'react'
import { useForm, FormProvider } from 'react-hook-form'
import { useParams } from 'react-router-dom'
import pathMap from 'src/paths/pathMap'
import MpciApiClient from '../Common/services/MpciApiClient'
import UaeMpciApiUrls from 'src/apiUrls/UaeMpciApiUrls'
import FormProperties from './FormProperties'
import ParentCard from 'src/components/era-package/shared/ParentCard'

function ViewPage({ history, showNotification }) {
  const { id } = useParams()
  const [isFetching, setIsFetching] = useState(false)

  const methods = useForm({
    defaultValues: { ...FormProperties.formikProps.initialValues }
  })

  useEffect(() => {
    MpciApiClient.getById(
      UaeMpciApiUrls.PARTY_MASTER_GET,
      id,
      (record) => {
        if (!record) {
          showNotification('error', 'Data not found.')
          history.push(pathMap.UAE_MPCI_PARTY_MASTER_LIST_VIEW)
        } else {
          methods.reset(FormProperties.toClientDataFormat(record))
        }
        setIsFetching(true)
      },
      () => {
        showNotification('error', 'Failed to load record.')
        history.push(pathMap.UAE_MPCI_PARTY_MASTER_LIST_VIEW)
        setIsFetching(true)
      }
    )
  }, [])

  if (!isFetching) return <p>Loading...</p>

  return (
    <ParentCard title='Party Master'>
      <FormProvider {...methods}>
        <form>
          <FormProperties.Fields
            disabled={true}
            showNotification={showNotification}
            shouldHideMap={{}}
          />
        </form>
      </FormProvider>
    </ParentCard>
  )
}

export default ViewPage
